import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col } from "react-bootstrap";
import { compressImages } from "../../../utils";

const FormCanonicos = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);
  const { photo, ...defaultValuesCleaned } = defaultValues;
  const {
    register,
    handleSubmit,
    // getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: defaultValuesCleaned.name,
      diocese: defaultValuesCleaned.diocese,
      startDate: defaultValuesCleaned.startDate,
      endDate: defaultValuesCleaned.endDate,
    },
  });

  // On submit del formulario
  const onSubmit = async (data) => {
    let files = data.photo;

    let compImg = true;
    // Si hay imagenes
    if (files.length) {
      compImg = await compressImages(files);
      // Si todo es correcto sustituimos las imagenes por las comprimidas
      if (compImg) {
        data.photo = compImg;
      } else {
        // Ponemos un error. El error se limpia solo cuando resubimos el campo
        setError("photo", {
          type: "manual",
          message: "Error compressing the image. Please try again, if the problem persist, contact an administrator",
        });
      }
    }

    if (compImg) {
      submissionHandler ? submissionHandler(data) : console.error("No handler provided for submission on form canonicos");
    }
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="name-comunidad">
          <Form.Label>{"Nombre *"}</Form.Label>
          <Form.Control
            name="name"
            placeholder={"Texto"}
            type="text"
            isInvalid={errors?.name}
            {...register("name", {
              required: "Este campo es obligatorio",
              maxLength: {
                value: 90,
                message: "El máximo de caracteres es 90",
              },
            })}
          />
          <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="diocesis-mission">
          <Form.Label>{"Diocesis"}</Form.Label>
          <Form.Control
            name="diocese"
            placeholder={"Texto"}
            type="text"
            isInvalid={errors?.diocese}
            {...register("diocese", {
              maxLength: {
                value: 90,
                message: "El máximo de caracteres es 90",
              },
            })}
          />
          <ErrorMessage errors={errors} name="diocese" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="startDate-comunidad">
          <Form.Label>{"Erigida"}</Form.Label>
          <Form.Control
            name="startDate"
            type="date"
            isInvalid={errors?.startDate}
            {...register("startDate", {
              validate: (date) => {
                return new Date(date) >= new Date() ? "La fecha no debe ser mayor a hoy" : true;
              },
            })}
          />
          <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="endDate-comunidad">
          <Form.Label>{"Suprimida"}</Form.Label>
          <Form.Control
            name="endDate"
            type="date"
            isInvalid={errors?.endDate}
            {...register("endDate", {
              validate: (date) => {
                return new Date(date) >= new Date() ? "La fecha no debe ser mayor a hoy" : true;
              },
            })}
          />
          <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="foto-comunidad">
          <Form.Label>{"Imagen"}</Form.Label>
          <Form.Control name="photo" type="file" isInvalid={errors?.photo} accept="image/*" {...register("photo")} />
          <ErrorMessage errors={errors} name="photo" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormCanonicos;
